import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { StaticText } from '@app/entities/models/static-text/static-text.model';

export interface StaticTextRepository {
  getStaticText(key: string, lang?: string): Observable<StaticText>;
}

export const STATIC_TEXT_REPOSITORY = new InjectionToken<StaticTextRepository>('STATIC_TEXT_REPOSITORY');
